const FRESH_FOR_MS = 10000;

let pending = null;
let fetchedAt = 0;

export const packsCatalogue = () => {
  if (!pending || Date.now() - fetchedAt > FRESH_FOR_MS) {
    fetchedAt = Date.now();
    pending = useApiV3().get('/packs');
    pending.then(({ error }) => {
      if (error) pending = null;
    });
  }
  return pending;
};
